import postal from 'postal';
import React from 'react';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const GiftCouponList = createReactClass({
  getInitialState() {
    return {
      coupons: this.props.initialCoupons
    };
  },
  componentWillMount() {
    const messagingChannelName = 'gift_messagingChannel';
    this.listeners = [];
    this.messagingChannel = postal.channel(messagingChannelName);
    this.listeners.push(this.messagingChannel.subscribe('newCoupon.gifted', this.handleNewCoupon));
  },
  componentWillUnmount() {
    this.listeners.forEach(function(sub) {
      postal.unsubscribe(sub);
    });
  },
  handleNewCoupon(data) {
    if (!data.coupon) return;
    const newCoupons = this.state.coupons;
    newCoupons.push(data.coupon);
    this.setState({ coupons: newCoupons }, this.handleShowCouponList);
  },
  handleShowCouponList() {
    // TODO: Fix
    // $.scrollTo('.gift-section-header', 800);
  },
  handleDownloadPdfLink(form_id, e) {
    const printForm = $(`#${form_id}`);
    const printJobHandler = new AT.Print.PrintJobHandler(printForm);
    $('#pdf-status .close').click(function() {
      $.colorbox.close();
    });
    $('#pdf-retry-button').click(function(e) {
      printJobHandler.submit(e);
    });
    printJobHandler.submit(e);
  },
  createCouponDiv(coupon) {
    let couponStatusString = null;
    let viewPdfLink = null;
    let url_base = '';
    if (typeof window !== 'undefined' && window.location)
      url_base = `${'https:' + '//'}${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

    const download_url = `${url_base}/gift/${coupon.id}/print`;
    const form_id = `pdf-form-${coupon.id}`;

    if (coupon.metadata.status == 'A') {
      couponStatusString = StringConstantsMixin.strings.COUPON.NOT_REDEEMED;
      viewPdfLink = (
        <form action="/api/private/coupon" className="pdf-form" id={form_id} method="post">
          <input id="api-key" name="key" type="hidden" value="3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i" />
          <input id="title" name="title" type="hidden" value="Gift AllTrails Pro" />
          <input id="url" name="url" type="hidden" value={download_url} />
          <input id="coupon_id" name="coupon_id" type="hidden" value={coupon.id} />
          <input type="radio" checked="checked" className="paper_size_radio hidden" id="paper_size_letter" value="letter" />
          <a onClick={this.handleDownloadPdfLink.bind(this, form_id)}>{StringConstantsMixin.strings.COUPON.VIEW_PDF}</a>
        </form>
      );
    } else couponStatusString = StringConstantsMixin.strings.COUPON.REDEEMED;
    return (
      <li key={`coupon-${coupon.id}`}>
        <div>{coupon.code}</div>
        <div>{viewPdfLink}</div>
        <div>{couponStatusString}</div>
      </li>
    );
  },
  render() {
    if (this.state.coupons && this.state.coupons.length > 0) {
      const couponItems = this.state.coupons.map(this.createCouponDiv);
      const couponList = (
        <ul className={`coupon-list ${StringConstantsMixin.constants.XLATE.NONE}`}>
          <li className="coupon-headers">
            <div>{StringConstantsMixin.strings.COUPON.PLACEHOLDER}</div>
            <div>{StringConstantsMixin.strings.COUPON.LINK_TO_PDF}</div>
            <div>{StringConstantsMixin.strings.STATUS}</div>
          </li>
          {couponItems}
        </ul>
      );
      return (
        <div>
          <h1 className={`gift-section-header ${StringConstantsMixin.constants.XLATE.NONE}`}>
            {StringConstantsMixin.strings.COUPON.MY_COUPON_CODES}
          </h1>
          {couponList}
        </div>
      );
    }
    return null;
  }
});

export { GiftCouponList };
